/* eslint-disable @typescript-eslint/no-unused-vars */
import useAccessCreateCheckout from "@hooks/trpc/useAccessCreateCheckout";

export const usePayment = (
  accessId: string,
  numberOfTickets: number,
  customPrice?: number,
  useGems?: boolean,
  confirmedAmountDueMinorUnits?: number,
  dataSharingConsent?: boolean,
  lineItems?: { item_id: string; quantity: number }[],
) => {
  const createPaymentSheetMutation = useAccessCreateCheckout();

  const checkoutWithBaseTransactionHash = async ({
    transactionHash,
  }: {
    transactionHash: string;
  }) => {
    await createPaymentSheetMutation.mutateAsync({
      accessId,
      numberOfTickets,
      baseTransactionHash: transactionHash,
      purchasePlatform: "app-web",
    });

    // For Base USDC on web, a successful mutation (no throw) means
    // the backend verified the transaction and issued access.
    return true;
  };

  return {
    paymentReady: true,
    openPaymentSheet: async () => {
      if (!lineItems) return false;
      const result = await createPaymentSheetMutation.mutateAsync({
        accessId,
        numberOfTickets,
        lineItems,
        purchasePlatform: "app-web",
      });
      if (result && "kind" in result && result.kind === "engine")
        window.location.assign(result.url);
      return false;
    },
    checkoutWithBaseTransactionHash,
  };
};

type OpenPaymentSheetParams = {
  onPresent?: () => void;
};
